import type { ReactNode } from "react";

import { StatusBadge } from "@/components/status-badge";

export function BenefitRow({
  icon,
  title,
  description,
  value,
  status,
  action,
}: {
  icon: ReactNode;
  title: string;
  description: string;
  value: string;
  status?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border p-3">
      <span className="grid h-9 w-9 place-items-center rounded-md bg-muted text-foreground">
        {icon}
      </span>
      <span className="min-w-0">
        <span className="block font-medium">{title}</span>
        <span className="block text-xs text-muted-foreground">
          {description}
        </span>
      </span>
      <span className="ml-auto text-sm font-semibold tabular-nums">
        {value}
      </span>
      {status && status !== "NONE" && <StatusBadge status={status} />}
      {action ? <span>{action}</span> : null}
    </div>
  );
}
